export default "__VITE_PUBLIC_ASSET__4172af2a__"